<div class="max-w-[600px] my-64 mx-auto text-center">
  <h1>404</h1>
  <h4>Oops! You're lost.</h4>
  <p class="m-24">The page you are looking for was not found.</p>
  <button class="flex flex-row items-center content-center gap-8 m-auto" nz-button nzType="primary" routerLink="/">
    <twaice-fe-svg-icon name="home" source="tabler" size="16px" />
    Click here to go back home
  </button>
</div>
